<script setup lang="ts">
import { CheckIcon } from "@heroicons/vue/20/solid";

// FormKit-style checkbox box that draws a tick and turns blue when `checked`.
withDefaults(defineProps<{ checked?: boolean }>(), { checked: false });
</script>

<template>
  <span
    aria-hidden="true"
    :class="[
      'formkit-decorator relative block aspect-[1/1] w-[1em] shrink-0 select-none rounded border text-lg shadow ring-blue-500 group-[]/multistep:shadow-none group-[]/repeater:shadow-none peer-focus-visible:ring-2 peer-focus-visible:ring-offset-1 peer-disabled:cursor-not-allowed peer-disabled:bg-neutral-100 dark:ring-offset-blue-500 dark:peer-focus-visible:ring-1 dark:peer-disabled:bg-neutral-600/50',
      checked
        ? 'border-blue-600 bg-blue-50 text-blue-600 dark:border-blue-600 dark:bg-blue-900 dark:text-blue-400'
        : 'border-neutral-400 bg-white text-transparent dark:border-neutral-500 dark:bg-transparent',
    ]"
  >
    <CheckIcon class="absolute left-1/2 top-1/2 h-full w-full max-w-[66.66%] -translate-x-1/2 -translate-y-1/2" />
  </span>
</template>
